interface UserMessagePrimitiveProps {
  rawContent: unknown;
  createdAt?: Date;
}

function textFromRawContent(rawContent: unknown): string {
  if (typeof rawContent === "string") return rawContent;
  if (!Array.isArray(rawContent)) return "";
  return rawContent
    .map((part) => {
      if (!part || typeof part !== "object") return "";
      const p = part as { type?: string; text?: string };
      if (p.type === "text" && typeof p.text === "string") return p.text;
      return "";
    })
    .filter(Boolean)
    .join("\n\n");
}

function imagesFromRawContent(rawContent: unknown): string[] {
  if (!Array.isArray(rawContent)) return [];
  return rawContent.flatMap((part) => {
    if (!part || typeof part !== "object") return [];
    const value = part as {
      type?: string;
      image?: string;
      url?: string;
      mediaType?: string;
    };
    if (value.type === "image" && typeof value.image === "string") {
      return [value.image];
    }
    if (
      value.type === "file" &&
      typeof value.url === "string" &&
      value.mediaType?.startsWith("image/")
    ) {
      return [value.url];
    }
    return [];
  });
}

export function UserMessagePrimitive({
  rawContent,
}: UserMessagePrimitiveProps) {
  const text = textFromRawContent(rawContent);
  const images = imagesFromRawContent(rawContent);
  return (
    <div style={{ display: "flex", justifyContent: "flex-end" }}>
      <div
        style={{
          maxWidth: "85%",
          border: "1px solid #3f3f46",
          borderRadius: 8,
          padding: "10px 12px",
          whiteSpace: "pre-wrap",
          fontSize: 13,
        }}
      >
        {images.length ? (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: images.length > 1 ? "1fr 1fr" : "1fr",
              gap: 6,
              marginBottom: text ? 8 : 0,
            }}
          >
            {images.map((src, index) => (
              <img
                key={`${src.slice(0, 80)}-${index}`}
                src={src}
                alt={`Chat attachment ${index + 1}`}
                loading="lazy"
                style={{
                  display: "block",
                  width: "100%",
                  maxWidth: 240,
                  maxHeight: 240,
                  borderRadius: 6,
                  objectFit: "cover",
                }}
              />
            ))}
          </div>
        ) : null}
        {text ? <span>{text}</span> : null}
      </div>
    </div>
  );
}
